import React from "react";
import {
  Row,
  Col,
  Tag,
  Typography,
  Divider,
  Empty,
  Space,
  Table,
  Avatar,
  Progress,
  Tabs,
} from "antd";
import {
  TeamOutlined,
  DollarOutlined,
  IdcardOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import THEME from "../theme";
import { formatMoney, formatDate } from "../utils";
import StyledCard from "../components/StyledCard";

const { Title, Text } = Typography;

const JudgementInfoTab = ({ judgeData }) => {
  const judges = judgeData?.judge || [];
  console.log("judgeData------->", judgeData);

  if (judges?.length === 0) {
    return (
      <StyledCard>
        <Empty description="ยังไม่มีข้อมูลหลังพิพากษา" />
      </StyledCard>
    );
  }

  const groupedJudges = judges?.reduce((acc, judge) => {
    const key = judge.judgeNumber;
    if (!acc[key]) acc[key] = [];
    acc[key].push(judge);
    return acc;
  }, {});

  const judgeNumbers = Object.keys(groupedJudges).sort((a, b) => a - b);

  const renderJudgeContent = (judgeNum) => {
    const judgesInGroup = groupedJudges[judgeNum];
    const firstJudge = judgesInGroup?.[0];

    const totalJudgement =
      Number(firstJudge?.judgement || 0) +
      Number(firstJudge?.AROTHR || 0) +
      Number(firstJudge?.costOfUselessness || 0);

    const totalPaid = (judgeData?.chqtran ?? [])
      ?.filter((r) => r.FLAG !== "C")
      .reduce((sum, item) => sum + parseFloat(item.PAYAMT_N || 0), 0);

    const totalPaidArothr = (judgeData?.chqtran_arothr ?? [])
      ?.filter((r) => r.FLAG !== "C")
      .reduce((sum, item) => sum + parseFloat(item.PAYAMT || 0), 0);

    const totalPaidAll = parseFloat(totalPaid + totalPaidArothr);
    const paymentProgress =
      totalJudgement > 0 ? (totalPaidAll / totalJudgement) * 100 : 0;

    return (
      <div>
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
          <Col xs={24} sm={12} md={6}>
            <div
              style={{
                textAlign: "center",
                padding: 20,
                background: `${THEME.danger}10`,
                borderRadius: 10,
                height: "100%",
              }}
            >
              <Text type="secondary" style={{ fontSize: 16 }}>
                ค่าชดใช้แทน
              </Text>
              <Title level={3} style={{ margin: "8px 0", color: THEME.danger }}>
                {formatMoney(firstJudge?.judgement)}
              </Title>
              <Space direction="vertical" size={0}>
                <Text type="secondary" style={{ fontSize: 14 }}>
                  ต้นเงิน: {formatMoney(firstJudge?.judgementLack)}
                </Text>
                <Text type="secondary" style={{ fontSize: 14 }}>
                  ดอกเบี้ย: {firstJudge?.interestRate || 0}% /ปี
                </Text>
              </Space>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div
              style={{
                textAlign: "center",
                padding: 20,
                background: `${THEME.warning}10`,
                borderRadius: 10,
                height: "100%",
              }}
            >
              <Text type="secondary" style={{ fontSize: 16 }}>
                ค่าขาดประโยชน์
              </Text>
              <Title
                level={3}
                style={{ margin: "8px 0", color: THEME.warning }}
              >
                {formatMoney(firstJudge?.lackOfBenefits)}
              </Title>
              <Text type="secondary" style={{ fontSize: 14 }}>
                ดอกเบี้ย: {firstJudge?.costRate || 0}% /ปี
              </Text>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div
              style={{
                textAlign: "center",
                padding: 20,
                background: `${THEME.info}10`,
                borderRadius: 10,
                height: "100%",
              }}
            >
              <Text type="secondary" style={{ fontSize: 16 }}>
                ลูกหนี้อื่นๆ
              </Text>
              <Title level={3} style={{ margin: "8px 0", color: THEME.info }}>
                {formatMoney(firstJudge?.AROTHR)}
              </Title>
              <Text type="secondary" style={{ fontSize: 14 }}>
                บาท
              </Text>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div
              style={{
                textAlign: "center",
                padding: 20,
                background: `${THEME.accent}10`,
                borderRadius: 10,
                height: "100%",
              }}
            >
              <Text type="secondary" style={{ fontSize: 16 }}>
                ดอกเบี้ยก่อนฟ้อง
              </Text>
              <Title level={3} style={{ margin: "8px 0", color: THEME.accent }}>
                {formatMoney(
                  judgeData.flagLoanNew === 1
                    ? 0
                    : firstJudge?.judgementInterest,
                )}
              </Title>
              <Text type="secondary" style={{ fontSize: 14 }}>
                บาท
              </Text>
            </div>
          </Col>
        </Row>

        <StyledCard style={{ marginBottom: 16 }}>
          <Row gutter={[24, 16]}>
            <Col xs={24} md={12}>
              <div
                style={{
                  background: "linear-gradient(135deg, #f6ffed 0%, #fff 100%)",
                  border: "1px solid #b7eb8f",
                  borderRadius: 12,
                  padding: "16px 20px",
                }}
              >
                <Space style={{ marginBottom: 10 }}>
                  <span style={{ fontSize: 18 }}>💳</span>
                  <Text strong style={{ fontSize: 16 }}>
                    ความคืบหน้าการชำระ
                  </Text>
                  <Tag
                    color={paymentProgress >= 100 ? "success" : "processing"}
                    style={{ borderRadius: 10 }}
                  >
                    {Number(paymentProgress ? paymentProgress.toFixed(1) : 0)}%
                  </Tag>
                </Space>
                <Progress
                  percent={Number(
                    paymentProgress ? paymentProgress.toFixed(1) : 0,
                  )}
                  strokeColor={{ "0%": THEME.success, "100%": "#52c41a" }}
                  trailColor="#e6f7e6"
                  size={{ width: "100%", height: 12 }}
                  style={{ marginBottom: 12 }}
                />
                <Row gutter={[8, 0]}>
                  <Col span={12}>
                    <div
                      style={{
                        background: "#fff",
                        border: "1px solid #f0f0f0",
                        borderRadius: 8,
                        padding: "6px 12px",
                        textAlign: "center",
                      }}
                    >
                      <Text
                        type="secondary"
                        style={{ fontSize: 16, display: "block" }}
                      >
                        ชำระแล้ว
                      </Text>
                      <Text
                        strong
                        style={{ color: THEME.success, fontSize: 18 }}
                      >
                        {formatMoney(totalPaidAll)}{" "}
                        <span
                          style={{
                            color: "#aaa",
                            fontSize: 14,
                            fontWeight: 400,
                          }}
                        >
                          บาท
                        </span>
                      </Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div
                      style={{
                        background: "#fff",
                        border: "1px solid #f0f0f0",
                        borderRadius: 8,
                        padding: "6px 12px",
                        textAlign: "center",
                      }}
                    >
                      <Text
                        type="secondary"
                        style={{ fontSize: 16, display: "block" }}
                      >
                        คงเหลือ
                      </Text>
                      <Text
                        strong
                        style={{ color: THEME.danger, fontSize: 18 }}
                      >
                        {formatMoney(Math.max(0, totalJudgement - totalPaidAll))}{" "}
                        <span
                          style={{
                            color: "#aaa",
                            fontSize: 14,
                            fontWeight: 400,
                          }}
                        >
                          บาท
                        </span>
                      </Text>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div
                style={{
                  background: "linear-gradient(135deg, #e6f4ff 0%, #fff 100%)",
                  border: "1px solid #91caff",
                  borderRadius: 12,
                  padding: "16px 20px",
                  height: "100%",
                }}
              >
                <Space style={{ marginBottom: 12 }}>
                  <span style={{ fontSize: 18 }}>📅</span>
                  <Text strong style={{ fontSize: 16 }}>
                    ข้อมูลดอกเบี้ย
                  </Text>
                </Space>
                <Row gutter={[10, 10]}>
                  {[
                    {
                      icon: "📌",
                      label: "วันเริ่มคิดดอกเบี้ย (เงินต้น)",
                      value: formatDate(firstJudge?.firstDate),
                      color: THEME.primary,
                    },
                    {
                      icon: "📌",
                      label: "วันเริ่มคิดดอกเบี้ย (ค่าขาดประโยชน์)",
                      value: formatDate(firstJudge?.costFirstDate),
                      color: THEME.warning,
                    },
                    {
                      icon: "📊",
                      label: "อัตราดอกเบี้ย (เงินต้น)",
                      value: `${firstJudge?.interestRate || 0}% ต่อปี`,
                      color: THEME.primary,
                    },
                    {
                      icon: "📊",
                      label: "อัตราดอกเบี้ย (ค่าขาดประโยชน์)",
                      value: `${firstJudge?.costRate || 0}% ต่อปี`,
                      color: THEME.warning,
                    },
                  ].map(({ icon, label, value, color }) => (
                    <Col span={12} key={label}>
                      <div
                        style={{
                          background: "#fff",
                          border: "1px solid #f0f0f0",
                          borderRadius: 8,
                          padding: "8px 10px",
                          height: "100%",
                        }}
                      >
                        <Text
                          type="secondary"
                          style={{
                            fontSize: 16,
                            display: "block",
                            marginBottom: 2,
                          }}
                        >
                          {icon} {label}
                        </Text>
                        <Text strong style={{ color, fontSize: 18 }}>
                          {value || "-"}
                        </Text>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          </Row>
        </StyledCard>

        {judgeData?.chqtran?.length > 0 && (
          <>
            {judgeData?.loanNew ? (
              <StyledCard
                title="ตารางการรับชำระรวม(ทำยอม)"
                icon={
                  <DollarOutlined
                    style={{ color: THEME.primary, fontSize: 18 }}
                  />
                }
                style={{ marginBottom: 16 }}
              >
                <Table
                  dataSource={judgeData.chqtran}
                  columns={[
                    {
                      title: "ลำดับ",
                      key: "index",
                      width: 60,
                      align: "center",
                      render: (_, __, idx) => idx + 1,
                    },
                    {
                      title: "วันที่ชำระ",
                      dataIndex: "PAYDT",
                      key: "PAYDT",
                      render: (val) => formatDate(val),
                    },
                    {
                      title: "ชื่อ-นามสกุล",
                      key: "name",
                      render: (_, r) => (
                        <Text>
                          {r.SNAM}
                          {r.NAME1} {r.NAME2}
                        </Text>
                      ),
                    },
                    { title: "รายการ", dataIndex: "FORDESC", key: "FORDESC" },
                    {
                      title: "เลขที่ใบเสร็จ",
                      dataIndex: "TMBILL",
                      key: "TMBILL",
                      render: (val) => (
                        <Text style={{ fontFamily: "monospace" }}>{val}</Text>
                      ),
                    },
                    {
                      title: "จำนวนเงิน",
                      dataIndex: "NETPAY",
                      key: "NETPAY",
                      align: "right",
                      render: (val) => (
                        <Text strong style={{ color: THEME.success }}>
                          {formatMoney(val)} บาท
                        </Text>
                      ),
                    },
                    {
                      title: "ผู้รับ",
                      dataIndex: "INPUT_BY",
                      key: "INPUT_BY",
                      align: "center",
                      render: (val) => <Tag color="blue">{val}</Tag>,
                    },
                  ]}
                  rowKey="wctId"
                  pagination={{
                    defaultPageSize: 5,
                    showSizeChanger: true,
                    pageSizeOptions: ["5", "10", "20", "50", "100"],
                  }}
                  size="middle"
                  scroll={{ x: 800 }}
                  summary={() => {
                    const totalNetpay = judgeData?.chqtran?.reduce(
                      (sum, r) => sum + Number(r.NETPAY || 0),
                      0,
                    );
                    return (
                      <Table.Summary.Row style={{ background: THEME.light }}>
                        <Table.Summary.Cell colSpan={4}>
                          <Text strong>รวมทั้งหมด</Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell align="right">
                          <Text strong style={{ color: THEME.success }}>
                            {formatMoney(totalNetpay)} บาท
                          </Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell />
                      </Table.Summary.Row>
                    );
                  }}
                />
              </StyledCard>
            ) : (
              <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                {judgeData?.chqtran?.filter((item) => item.FORDESC === "ค่าแทน")
                  ?.length > 0 && (
                  <Col xs={24} lg={12}>
                    <StyledCard
                      title="ตารางการรับชำระรวม - ค่าแทน"
                      icon={
                        <DollarOutlined
                          style={{ color: THEME.danger, fontSize: 18 }}
                        />
                      }
                      style={{ height: "100%" }}
                    >
                      <Table
                        dataSource={judgeData?.chqtran?.filter(
                          (item) => item.FORDESC === "ค่าแทน",
                        )}
                        columns={[
                          {
                            title: "#",
                            key: "index",
                            width: 10,
                            align: "center",
                            render: (_, __, idx) => idx + 1,
                          },
                          {
                            title: "วันที่ชำระ",
                            dataIndex: "PAYDT",
                            key: "PAYDT",
                            width: 40,
                            render: (val) => formatDate(val),
                          },
                          {
                            title: "ชื่อ-นามสกุล",
                            key: "name",
                            ellipsis: true,
                            width: 70,
                            render: (_, r) => (
                              <Text
                                style={{
                                  fontFamily: "monospace",
                                  fontSize: 14,
                                }}
                              >
                                {r.SNAM}
                                {r.NAME1} {r.NAME2}
                              </Text>
                            ),
                          },
                          {
                            title: "ใบเสร็จ",
                            dataIndex: "TMBILL",
                            key: "TMBILL",
                            width: 50,
                            render: (val) => (
                              <Text
                                style={{
                                  fontFamily: "monospace",
                                  fontSize: 14,
                                }}
                              >
                                {val}
                              </Text>
                            ),
                          },
                          {
                            title: "จำนวนเงิน",
                            dataIndex: "NETPAY",
                            key: "NETPAY",
                            width: 40,
                            align: "right",
                            render: (val, record) => (
                              <Text
                                style={{
                                  color: record.FLAG === "C" ? "red" : "green",
                                }}
                              >
                                {formatMoney(val)}
                              </Text>
                            ),
                          },
                          {
                            title: "สถานะ",
                            dataIndex: "FLAG",
                            key: "FLAG",
                            width: 40,
                            align: "right",
                            render: (val) => (
                              <Tag color={val === "C" ? "red" : "green"}>
                                {val === "C" ? "ยกเลิก" : "รับปกติ"}
                              </Tag>
                            ),
                          },
                          {
                            title: "ผู้รับ",
                            dataIndex: "INPUT_BY",
                            key: "INPUT_BY",
                            align: "center",
                            width: 40,
                            render: (val) => <Tag color="blue">{val}</Tag>,
                          },
                        ]}
                        rowKey="wctId"
                        pagination={{
                          defaultPageSize: 5,
                          showSizeChanger: true,
                        }}
                        size="small"
                        summary={() => {
                          const total = judgeData?.chqtran
                            ?.filter((r) => r.FLAG !== "C")
                            .reduce((sum, r) => sum + Number(r.NETPAY || 0), 0);
                          return (
                            <Table.Summary.Row
                              style={{ background: THEME.light }}
                            >
                              <Table.Summary.Cell colSpan={4}>
                                <Text strong>รวมชำระ</Text>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell align="right">
                                <Text
                                  strong
                                  style={{
                                    color: THEME.success,
                                    fontSize: 16,
                                  }}
                                >
                                  {formatMoney(total)}
                                </Text>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell />
                            </Table.Summary.Row>
                          );
                        }}
                      />
                    </StyledCard>
                  </Col>
                )}
                {judgeData?.chqtran?.filter(
                  (item) => item.FORDESC === "ค่าขาดประโยชน์",
                )?.length > 0 && (
                  <Col xs={24} lg={12}>
                    <StyledCard
                      title="ตารางการรับชำระรวม - ค่าขาดประโยชน์"
                      icon={
                        <DollarOutlined
                          style={{ color: THEME.warning, fontSize: 18 }}
                        />
                      }
                      style={{ height: "100%" }}
                    >
                      <Table
                        dataSource={judgeData?.chqtran?.filter(
                          (item) => item.FORDESC === "ค่าขาดประโยชน์",
                        )}
                        columns={[
                          {
                            title: "#",
                            key: "index",
                            width: 10,
                            align: "center",
                            render: (_, __, idx) => idx + 1,
                          },
                          {
                            title: "วันที่ชำระ",
                            dataIndex: "PAYDT",
                            key: "PAYDT",
                            width: 40,
                            render: (val) => formatDate(val),
                          },
                          {
                            title: "ชื่อ-นามสกุล",
                            key: "name",
                            width: 70,
                            ellipsis: true,
                            render: (_, r) => (
                              <Text
                                style={{
                                  fontFamily: "monospace",
                                  fontSize: 14,
                                }}
                              >
                                {r.SNAM}
                                {r.NAME1} {r.NAME2}
                              </Text>
                            ),
                          },
                          {
                            title: "ใบเสร็จ",
                            dataIndex: "TMBILL",
                            key: "TMBILL",
                            width: 50,
                            render: (val) => (
                              <Text
                                style={{
                                  fontFamily: "monospace",
                                  fontSize: 14,
                                }}
                              >
                                {val}
                              </Text>
                            ),
                          },
                          {
                            title: "จำนวนเงิน",
                            dataIndex: "NETPAY",
                            key: "NETPAY",
                            width: 40,
                            align: "right",
                            render: (val, record) => (
                              <Text
                                style={{
                                  color: record.FLAG === "C" ? "red" : "green",
                                }}
                              >
                                {formatMoney(val)}
                              </Text>
                            ),
                          },
                          {
                            title: "สถานะ",
                            dataIndex: "FLAG",
                            key: "FLAG",
                            width: 40,
                            align: "right",
                            render: (val) => (
                              <Tag color={val === "C" ? "red" : "green"}>
                                {val === "C" ? "ยกเลิก" : "รับปกติ"}
                              </Tag>
                            ),
                          },
                          {
                            title: "ผู้รับ",
                            dataIndex: "INPUT_BY",
                            key: "INPUT_BY",
                            align: "center",
                            width: 50,
                            render: (val) => <Tag color="blue">{val}</Tag>,
                          },
                        ]}
                        rowKey="wctId"
                        pagination={{
                          defaultPageSize: 5,
                          showSizeChanger: true,
                        }}
                        size="small"
                        summary={() => {
                          const total = judgeData?.chqtran
                            ?.filter((r) => r.FLAG !== "C")
                            .reduce((sum, r) => sum + Number(r.NETPAY || 0), 0);
                          return (
                            <Table.Summary.Row
                              style={{ background: THEME.light }}
                            >
                              <Table.Summary.Cell colSpan={4}>
                                <Text strong>รวมชำระ</Text>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell align="right">
                                <Text
                                  strong
                                  style={{
                                    color: THEME.success,
                                    fontSize: 16,
                                  }}
                                >
                                  {formatMoney(total)}
                                </Text>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell />
                            </Table.Summary.Row>
                          );
                        }}
                      />
                    </StyledCard>
                  </Col>
                )}
              </Row>
            )}
          </>
        )}

        {judgeData?.chqtran_arothr?.length > 0 && (
          <>
            <Row style={{ marginBottom: 16 }}>
              <Col>
                <StyledCard
                  title="ตารางการรับลูกหนี้อื่น ๆ"
                  icon={
                    <DollarOutlined
                      style={{ color: THEME.danger, fontSize: 18 }}
                    />
                  }
                  style={{ height: "100%" }}
                >
                  <Table
                    dataSource={judgeData?.chqtran_arothr}
                    columns={[
                      {
                        title: "#",
                        key: "index",
                        width: 10,
                        align: "center",
                        render: (_, __, idx) => idx + 1,
                      },
                      {
                        title: "วันที่ชำระ",
                        dataIndex: "PAYDT",
                        key: "PAYDT",
                        width: 40,
                        render: (val) => formatDate(val),
                      },
                      {
                        title: "ชื่อ-นามสกุล",
                        key: "name",
                        ellipsis: true,
                        width: 70,
                        render: (_, r) => (
                          <Text
                            style={{
                              fontFamily: "monospace",
                              fontSize: 14,
                            }}
                          >
                            {r.SNAM}
                            {r.NAME1} {r.NAME2}
                          </Text>
                        ),
                      },
                      {
                        title: "ใบเสร็จ",
                        dataIndex: "TMBILL",
                        key: "TMBILL",
                        width: 30,
                        render: (val) => (
                          <Text
                            style={{
                              fontFamily: "monospace",
                              fontSize: 14,
                            }}
                          >
                            {val}
                          </Text>
                        ),
                      },
                      {
                        title: "ประเภทจ่าย",
                        dataIndex: "PAYTYP",
                        key: "PAYTYP",
                        width: 50,
                        align: "center",
                        render: (val) => (
                          <Text
                            style={{
                              fontFamily: "monospace",
                              fontSize: 14,
                            }}
                          >
                            {val === "01" ? "เงินสด" : "โอน"}
                          </Text>
                        ),
                      },
                      {
                        title: "ค่า",
                        dataIndex: "FORDESC",
                        key: "FORDESC",
                        width: 30,
                        align: "center",
                        render: (val) => (
                          <Text
                            style={{
                              fontFamily: "monospace",
                              fontSize: 14,
                            }}
                          >
                            {val}
                          </Text>
                        ),
                      },
                      {
                        title: "จำนวนเงิน",
                        dataIndex: "NETPAY",
                        key: "NETPAY",
                        width: 40,
                        align: "right",
                        render: (val, record) => (
                          <Text
                            style={{
                              color: record.FLAG === "C" ? "red" : "green",
                            }}
                          >
                            {formatMoney(val)}
                          </Text>
                        ),
                      },
                      {
                        title: "สถานะ",
                        dataIndex: "FLAG",
                        key: "FLAG",
                        width: 40,
                        align: "right",
                        render: (val) => (
                          <Tag color={val === "C" ? "red" : "green"}>
                            {val === "C" ? "ยกเลิก" : "รับปกติ"}
                          </Tag>
                        ),
                      },
                      {
                        title: "ผู้รับ",
                        dataIndex: "INPUT_BY",
                        key: "INPUT_BY",
                        align: "center",
                        width: 40,
                        render: (val) => <Tag color="blue">{val}</Tag>,
                      },
                    ]}
                    rowKey="wctId"
                    pagination={{
                      defaultPageSize: 5,
                      showSizeChanger: true,
                    }}
                    size="small"
                    summary={() => {
                      const total = judgeData?.chqtran_arothr
                        ?.filter((r) => r.FLAG !== "C")
                        .reduce((sum, r) => sum + Number(r.NETPAY || 0), 0);

                      return (
                        <Table.Summary.Row style={{ background: THEME.light }}>
                          <Table.Summary.Cell colSpan={6}>
                            <Text strong>รวมชำระ</Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell align="right">
                            <Text
                              strong
                              style={{
                                color: THEME.success,
                                fontSize: 16,
                              }}
                            >
                              {formatMoney(total)}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell colSpan={2} />
                        </Table.Summary.Row>
                      );
                    }}
                  />
                </StyledCard>
              </Col>
            </Row>
          </>
        )}

        <StyledCard
          title={`รายละเอียดจำเลยในคำพิพากษานี้ (${judgesInGroup?.length} คน)`}
          icon={<TeamOutlined style={{ color: THEME.primary, fontSize: 18 }} />}
          style={{ padding: 10 }}
        >
          <Tabs
            type="card"
            items={judgesInGroup?.map((defendant) => {
              // 1. หาข้อมูลจาก array cal ที่ CUSTOMER_ID ตรงกับจำเลยคนนี้
              return {
                key: String(defendant?.idJudgeDef),
                label: (
                  <Space>
                    <Avatar
                      size={24}
                      style={{ background: THEME.gradient, fontSize: 14 }}
                    >
                      {defendant?.defendantNumber}
                    </Avatar>
                    {defendant?.SNAM}
                    {defendant?.NAME1} {defendant?.NAME2}
                  </Space>
                ),
                children: (
                  <div
                    style={{
                      padding: 20,
                      background: THEME.light,
                      borderRadius: 10,
                      borderLeft: `4px solid ${THEME.primary}`,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        marginBottom: 16,
                      }}
                    >
                      <Avatar size={56} style={{ background: THEME.gradient }}>
                        {defendant?.defendantNumber}
                      </Avatar>
                      <div style={{ flex: 1 }}>
                        <Text strong style={{ fontSize: 18 }}>
                          {defendant?.SNAM}
                          {defendant?.NAME1} {defendant?.NAME2}
                        </Text>
                        <br />
                        <Space size={4}>
                          <Tag color="geekblue">
                            คำพิพากษาที่ {defendant?.judgeNumber}
                          </Tag>
                          <Tag color="blue">
                            จำเลยที่ {defendant?.defendantNumber}
                          </Tag>
                          <Tag
                            color={
                              judgeData?.flagLoanNew === 1 ? "green" : "orange"
                            }
                          >
                            {judgeData?.flagLoanNew === 1 ? "ทำยอม" : "พิพากษา"}
                          </Tag>
                        </Space>
                      </div>
                    </div>
                    <Row gutter={[12, 8]}>
                      <Col span={24}>
                        <Text type="secondary" style={{ fontSize: 16 }}>
                          <IdcardOutlined style={{ marginRight: 6 }} />
                          เลขบัตรประชาชน/ทะเบียนนิติบุคคล
                        </Text>
                        <br />
                        <Text
                          copyable
                          strong
                          style={{ fontFamily: "monospace", fontSize: 18 }}
                        >
                          {defendant?.CUSCOD}
                        </Text>
                      </Col>
                    </Row>
                    <Divider style={{ margin: "12px 0" }} />
                    <Row
                      gutter={[12, 12]}
                      style={{ marginLeft: 8, marginTop: 8 }}
                    >
                      {[
                        // {
                        //   label: "ยอดปิดสัญญา",
                        //   // 2. ใช้ matchedCal.closingbalance แทน cal.closingbalance
                        //   value: formatMoney(matchedCal.closingbalance),
                        //   color: THEME.success,
                        //   icon: "💰",
                        // },
                        {
                          label: "ยอดชดใช้แทน",
                          value: formatMoney(defendant?.judgement),
                          color: THEME.danger,
                          icon: "💰",
                        },
                        {
                          label: "ค่าขาดประโยชน์",
                          value: formatMoney(defendant?.lackOfBenefits),
                          color: THEME.primary,
                          icon: "📉",
                        },
                        {
                          label: "ชำระแล้ว",
                          value: formatMoney(defendant?.PAY),
                          color: THEME.success,
                          icon: "✅",
                        },
                        {
                          label: "ค่าขาดประโยชน์รายเดือน",
                          value: formatMoney(
                            defendant?.costOfUselesenessPerMonth,
                          ),
                          color: THEME.warning,
                          icon: "📆",
                        },
                        {
                          label: "ค่าติดตาม",
                          value: formatMoney(defendant?.trackingFee),
                          color: THEME.primary,
                          icon: "🔍",
                        },
                        {
                          label: "ระยะเวลาค่าขาดประโยชน์",
                          value: defendant?.costOfUselesenessMonth,
                          color: THEME.warning,
                          icon: "📆",
                        },
                        {
                          label: "ค่าทนาย",
                          value: formatMoney(defendant?.attorneyFees),
                          color: THEME.primary,
                          icon: "⚖️",
                        },
                        {
                          label: "ค่าธรรมเนียม",
                          value: formatMoney(defendant?.fee),
                          color: THEME.primary,
                          icon: "🧾",
                        },
                      ].map(({ label, value, color, icon }) => (
                        <Col span={12} key={label}>
                          <div
                            style={{
                              background: "#fff",
                              border: "1px solid #f0f0f0",
                              borderRadius: 8,
                              padding: "8px 12px",
                              display: "flex",
                              alignItems: "center",
                              gap: 10,
                            }}
                          >
                            <span style={{ fontSize: 18 }}>{icon}</span>
                            <div>
                              <Text
                                type="secondary"
                                style={{ fontSize: 16, display: "block" }}
                              >
                                {label}
                              </Text>
                              <Text strong style={{ color, fontSize: 18 }}>
                                {value}{" "}
                                <span
                                  style={{
                                    color: "#aaa",
                                    fontWeight: 400,
                                    fontSize: 12,
                                  }}
                                >
                                  {value === defendant?.costOfUselesenessMonth
                                    ? "เดือน"
                                    : "บาท"}
                                </span>
                              </Text>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                    <Divider style={{ margin: "12px 0" }} />
                    <Table
                      dataSource={judgeData?.chqtran?.filter(
                        (item) => item?.CUSTOMER_ID === defendant?.CUSTOMER_ID,
                      )}
                      columns={[
                        {
                          title: "#",
                          key: "index",
                          align: "center",
                          render: (_, __, idx) => idx + 1,
                        },
                        {
                          title: "วันที่ชำระ",
                          dataIndex: "PAYDT",
                          key: "PAYDT",
                          align: "center",
                          render: (val) => formatDate(val),
                        },
                        {
                          title: "ใบเสร็จ",
                          dataIndex: "TMBILL",
                          key: "TMBILL",
                          align: "center",
                          render: (val) => (
                            <Text
                              style={{
                                fontFamily: "monospace",
                                fontSize: 16,
                              }}
                            >
                              {val}
                            </Text>
                          ),
                        },
                        {
                          title: "ประเภทจ่าย",
                          dataIndex: "FORDESC",
                          key: "FORDESC",
                          align: "center",
                        },
                        {
                          title: "จำนวนเงิน",
                          dataIndex: "NETPAY",
                          key: "NETPAY",
                          width: 40,
                          align: "right",
                          render: (val, record) => (
                            <Text
                              style={{
                                color: record.FLAG === "C" ? "red" : "green",
                              }}
                            >
                              {formatMoney(val)}
                            </Text>
                          ),
                        },
                        {
                          title: "สถานะ",
                          dataIndex: "FLAG",
                          key: "FLAG",
                          width: 40,
                          align: "right",
                          render: (val) => (
                            <Tag color={val === "C" ? "red" : "green"}>
                              {val === "C" ? "ยกเลิก" : "รับปกติ"}
                            </Tag>
                          ),
                        },
                        {
                          title: "ผู้รับ",
                          dataIndex: "INPUT_BY",
                          key: "INPUT_BY",
                          align: "center",
                          render: (val) => <Tag color="blue">{val}</Tag>,
                        },
                      ]}
                      rowKey="wctId"
                      pagination={{
                        defaultPageSize: 5,
                        showSizeChanger: true,
                      }}
                      size="small"
                      scroll={{ x: 500 }}
                      summary={() => {
                        // 3. กรอง CUSTOMER_ID ให้ตรงกับจำเลยคนนี้ เพื่อให้ยอดรวมถูกต้อง
                        const total = judgeData?.chqtran
                          ?.filter(
                            (r) =>
                              r.FLAG !== "C" &&
                              r.CUSTOMER_ID === defendant?.CUSTOMER_ID,
                          )
                          .reduce((sum, r) => sum + Number(r.NETPAY || 0), 0);

                        return (
                          <Table.Summary.Row
                            style={{ background: THEME.light }}
                          >
                            <Table.Summary.Cell colSpan={4}>
                              <Text strong>รวมชำระ</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                              <Text
                                strong
                                style={{ color: THEME.success, fontSize: 18 }}
                              >
                                {formatMoney(total)}
                              </Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell />
                          </Table.Summary.Row>
                        );
                      }}
                    />
                  </div>
                ),
              };
            })}
          />
        </StyledCard>
      </div>
    );
  };

  const judgeTabs = judgeNumbers
    .filter((judgeNum) => judgeNum !== "0") // ✅ กรอง key "0" ออก
    .map((judgeNum) => ({
      key: judgeNum,
      label: (
        <span>
          <SafetyCertificateOutlined />
          คำพิพากษาที่ {judgeNum}
          <Tag color="blue" style={{ marginLeft: 8 }}>
            {groupedJudges[judgeNum]?.length} คน
          </Tag>
        </span>
      ),
      children: renderJudgeContent(judgeNum),
    }));

  if (!judgeTabs?.length) return null;

  return (
    <Tabs
      type="card"
      size="middle"
      items={judgeTabs}
      style={{ marginBottom: 16 }}
    />
  );
};

export default JudgementInfoTab;
